module.exports = __webpack_public_path__ + "static/media/Group 35.13c9a6bd.svg";